export default {
  notifications: state => state.notifications
}
